import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'hiv_aids_status_real_perceived_3'

export const dataPointDefinition = {
  retracedId: 'hiv_aids_status_real_perceived_3',
  name: 'HIV / AIDS Status (real or perceived)',
  description:
    'HIV/AIDS Status (real or perceived) refers to a person�s actual or perceived infection with HIV/AIDS. HIV refers to the Human Immunodeficiency Virus, a virus that weakens the body�s immune system, ultimately causing AIDS, which is the Acquired Immune Deficiency Syndrome, a cluster of medical conditi',
  meta: {
    slcpMeta: {
      key: 'wt-dis-15x',
      number: 'WT-DIS-8-8',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'wt-dis-7',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[1],wt-dis-6,Yes',
      machineShowHide: '[1],wt-dis-6,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wt-dis-15x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 37140,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
